import { useState } from 'react';

import { consoleDev, ConsoleStatus, fetchData } from '@quizzach/utils';
import { IProfileInfo } from '@quizzach/interfaces';
import { useAuth } from '@quizzach/contexts';

export const useProfile = () => {
	const [error, setError] = useState<boolean>(false);
	const [errorCode, setErrorCode] = useState<number | undefined>();
	const { setProfileInfo } = useAuth();

	const updateProfile = async (state: Partial<IProfileInfo>) => {
		try {
			const response = await fetchData<IProfileInfo>(
				`/api/profile`,
				{
					method: 'PATCH',
					body: JSON.stringify(state),
				},
				{
					authRoute: true,
				}
			);

			if (response.status >= 300) {
				consoleDev('useProfile', ConsoleStatus.HTTP, response.status);

				console.log('setting error to true and status', response.status);
				setError(true);
				setErrorCode(response.status);
			} else {
				consoleDev('useProfile', ConsoleStatus.SUCC);
				if (response.data) {
					setProfileInfo(response.data);
				}
				setError(false);
			}
		} catch (err) {
			consoleDev('useProfile', ConsoleStatus.NET, err);
			setError(true);
		}
	};

	return {
		error,
		errorCode,
		updateProfile,
	};
};
